import styled from 'styled-components';

export default styled.div`
    padding: 10px 15px 0 15px;
    display: flex;
    justify-content: space-between;
    font: inherit;
`;
